"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/tenant.js"));
var tenantPackage = _interopRequireWildcard(require("@/api/tenantPackage.js"));
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function normalizeDomain(url) {
  if (!url) return '';
  var v = String(url).trim();
  while (v.endsWith('/')) v = v.slice(0, -1);
  return v;
}
var _default = exports.default = {
  name: "roleEdit",
  props: {
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      pram: {
        name: null,
        status: null,
        code: null,
        adminAccount: null,
        adminPassword: null,
        id: null,
        packages: [],
        publishTypeList: [],
        websiteDomain: '',
        h5Domain: ''
      },
      packageList: [],
      constants: this.$constants
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.handleGetPackageList();
  },
  methods: {
    handleGetPackageList: function handleGetPackageList() {
      var _this = this;
      var _pram = {
        page: 1,
        limit: this.constants.page.limit[4],
        status: 1
      };
      tenantPackage.getRoleList(_pram).then(function (data) {
        _this.packageList = data;
      });
    },
    close: function close() {
      this.$emit('hideEditDialog');
    },
    initEditData: function initEditData() {
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        name = _this$editData.name,
        status = _this$editData.status,
        id = _this$editData.id,
        code = _this$editData.code,
        packages = _this$editData.packages,
        adminAccount = _this$editData.adminAccount,
        publishTypes = _this$editData.publishTypes,
        websiteDomain = _this$editData.websiteDomain,
        h5Domain = _this$editData.h5Domain;
      this.pram.name = name;
      this.pram.status = status;
      this.pram.code = code;
      this.pram.adminAccount = adminAccount;
      this.pram.id = id;
      this.pram.websiteDomain = websiteDomain || '';
      this.pram.h5Domain = h5Domain || '';
      this.pram.publishTypeList = publishTypes ? String(publishTypes).split(',').map(function (s) {
        return s.trim();
      }).filter(Boolean) : [];
      if (packages && packages.length > 0) {
        if (typeof packages === 'string') {
          this.pram.packages = packages.split(',').map(function (item) {
            return Number.parseInt(item);
          });
        } else if (Array.isArray(packages)) {
          this.pram.packages = packages.map(function (item) {
            return Number.parseInt(item);
          });
        }
      } else {
        this.pram.packages = [];
      }
    },
    buildSubmitData: function buildSubmitData() {
      var types = this.pram.publishTypeList || [];
      return _objectSpread(_objectSpread({}, this.pram), {}, {
        packages: this.pram.packages.join(','),
        publishTypes: types.join(','),
        websiteDomain: types.includes('pc') ? normalizeDomain(this.pram.websiteDomain) : '',
        h5Domain: types.includes('h5') ? normalizeDomain(this.pram.h5Domain) : ''
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this2.isCreate === 0) {
          _this2.handlerSave();
        } else {
          _this2.handlerEdit();
        }
      });
    }),
    handlerSave: function handlerSave() {
      var _this3 = this;
      var submitData = this.buildSubmitData();
      roleApi.addRole(submitData).then(function (data) {
        _this3.$message.success('创建租户成功');
        _this3.$emit('hideEditDialog');
      }).catch(function (error) {
        _this3.$message.error('创建租户失败');
        console.error('创建租户错误:', error);
      });
    },
    handlerEdit: function handlerEdit() {
      var _this4 = this;
      var submitData = this.buildSubmitData();
      roleApi.updateRole(submitData).then(function (data) {
        _this4.$message.success('更新租户成功');
        _this4.$emit('hideEditDialog');
      }).catch(function (error) {
        _this4.$message.error('更新租户失败');
        console.error('更新租户错误:', error);
      });
    }
  }
};